import { useEffect, useRef } from "react";
import { useReducedFx } from "./motion-utils";

export const Ambient = () => {
  const canvas = useRef(null);
  const reduced = useReducedFx();

  useEffect(() => {
    if (reduced || !canvas.current) return;
    const c = canvas.current;
    const ctx = c.getContext("2d");
    let raf, w, h, particles = [];
    const dpr = Math.min(window.devicePixelRatio || 1, 2);

    const resize = () => {
      w = c.width = window.innerWidth * dpr;
      h = c.height = window.innerHeight * dpr;
      c.style.width = "100%"; c.style.height = "100%";
      const count = Math.round((window.innerWidth * window.innerHeight) / 26000);
      particles = Array.from({ length: count }, () => ({
        x: Math.random() * w, y: Math.random() * h,
        r: (Math.random() * 1.4 + 0.3) * dpr,
        vy: -(Math.random() * 0.22 + 0.05) * dpr,
        vx: (Math.random() - 0.5) * 0.12 * dpr,
        a: Math.random() * 0.5 + 0.15,
        p: Math.random() * Math.PI * 2,
      }));
    };
    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      for (const p of particles) {
        p.y += p.vy; p.x += p.vx; p.p += 0.02;
        if (p.y < -10) { p.y = h + 10; p.x = Math.random() * w; }
        const alpha = p.a * (0.55 + 0.45 * Math.sin(p.p));
        ctx.beginPath();
        ctx.fillStyle = `rgba(180,215,255,${alpha})`;
        ctx.shadowBlur = 8 * dpr; ctx.shadowColor = "rgba(142,197,255,0.8)";
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };
    resize();
    window.addEventListener("resize", resize);
    raf = requestAnimationFrame(draw);
    return () => { window.removeEventListener("resize", resize); cancelAnimationFrame(raf); };
  }, [reduced]);

  return (
    <div className="cg-ambient" aria-hidden="true" data-testid="ambient-fx">
      {!reduced && <canvas ref={canvas} className="cg-particles" />}
      <div className="cg-grain" />
    </div>
  );
};
